import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  Flex,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  MESSAGE_BOX_VARIANT_TIP,
  MessageBox,
  TEXT_VARIANT_STANDARD,
  TITLE_VARIANT_S,
  Text,
  Title,
} from 'mailup-web-components'

import ModalDataSyncPromo from 'Components/ModalDataSyncPromo'

import { openMshopAdditionalOptions } from 'Helpers/ecommerce'

const DataSyncPromo: FC = () => {
  const intl = useIntl()

  const [show, setShow] = useState(false)

  const openModal = (): void => {
    setShow(true)
  }

  const handleCancel = (): void => {
    setShow(false)
  }

  return (
    <>
      <ModalDataSyncPromo
        show={show}
        onCancel={handleCancel}
        onConfirm={openMshopAdditionalOptions}
      />
      <MessageBox
        variant={MESSAGE_BOX_VARIANT_TIP}
        data-mu-test="data-sync-promo"
      >
        <Flex flexDirection="column" gap="8px">
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.DataSyncPromo.MessageTitle' })}
          </Title>

          <Text variant={TEXT_VARIANT_STANDARD}>
            {intl.formatMessage(
              { id: 'Load.DataSyncPromo.MessageDescription' },
              {
                link: (chunks) => (
                  <Link
                    data-mu-test="data-sync-promo__open-modal"
                    variant={LINK_VARIANT_HIGHLIGHT}
                    onClick={openModal}
                  >
                    {chunks}
                  </Link>
                ),
              },
            )}
          </Text>
        </Flex>
      </MessageBox>
    </>
  )
}

export default DataSyncPromo
